export const LANGUAGES = {
    en: 'English',
    es: 'Espanõl',
};

export const LanguageTypes: string[] = ['en', 'es'];

export type IPreferredLanguagesKeys = 'en' | 'es';


